import { StarIcon as StarIconOutline } from "@heroicons/react/24/outline";
import { StarIcon as StarIconSolid } from "@heroicons/react/24/solid";

export default function RatingStars({ rating }: { rating: number }) {
  const totalStars = 5;
  const filledStars = Math.round(Number(rating));

  return (
    <div className="flex">
      {[...Array(totalStars)].map((_, index) => (
        <span key={index}>
          {index < filledStars ? (
            <StarIconSolid className="w-5 h-5 text-yellow-400" />
          ) : (
            <StarIconOutline className="w-5 h-5 text-gray-300" />
          )}
        </span>
      ))}
    </div>
  );
}
